import gql from 'graphql-tag';
export const StatFeatureOrgOccupancy = gql `
    fragment StatFeatureOrgOccupancy on OrgOccupancyFeatureSettingsFlags {
        isEnabled
    }
`;
